import { render } from "./GlobalCard.vue?vue&type=template&id=0b765bb4&scoped=true"
const script = {}

import "./GlobalCard.vue?vue&type=style&index=0&id=0b765bb4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b765bb4"

export default script